import { useEffect, useMemo, useState } from "react";
import { Billings, billingsColumns } from "./BillingsColumns";
import { fetchAssets, fetchBillings } from "@/apiCalls/apiCalls";
import Spinner from "../spinnner/Spinner";
import { DataTable } from "@/dataTables/data-table";
import { errorNotification } from "@/utils/Notification";
import { BillinDataTable } from "./BillingDataTables";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import { Button } from "@/components/ui/button"
import BillBeaconDrawer from "./BillBeaconDrawer";

function BillingsFn() {
    const [data, setData] = useState<Billings[]>([]);
    const [loading, setLoading] = useState<boolean>(true)
    const [showbillBeaconDrawer, setShowbillBeaconDrawer] = useState<boolean>(false)
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();


    const fetchBillings = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/billings', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoading(false)
            })
        return () => {
            isMounted = false
            controller.abort()
        };
    };

    useEffect(() => {
        fetchBillings()
    }, [])


    const billingsColumnsData = useMemo(() => billingsColumns(), [])

    if (loading) {
        return <Spinner />
    }

    return (
        <>
            <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>
                <Button
                    variant='default'
                    className="flex items-center justify-end"
                    onClick={() => setShowbillBeaconDrawer(!showbillBeaconDrawer)}
                >
                    Bill Beacons
                </Button>
                <BillinDataTable columns={billingsColumnsData} data={data} />
                <BillBeaconDrawer
                    showbillBeaconDrawer={showbillBeaconDrawer}
                    setShowbillBeaconDrawer={setShowbillBeaconDrawer}
                />
            </main>
        </>
    )
}
export default BillingsFn